const userIndex = {
    path: '/user',
    component: () => import('@/views/user/index'),
    hidden: true,
    redirect: '/user/course',
    name: 'user',
    children: [
        {
            path: '/user/order',
            component: () => import('@/views/user/order'),
            name: 'userOrder'
        },
        {
            path: '/user/collect',
            component: () => import('@/views/user/collect'),
            name: 'userCollect'
        },
        {
            path: '/user/course',
            component: () => import('@/views/user/course'),
            name: 'userCourse'
        },
        {
            path: '/user/giveorder',
            component: () => import('@/views/user/giveorder.vue'),
            name: 'giveorder'
        }
    ]

}

export default userIndex
